import React, { useState, useEffect } from 'react';
import resources from '../../../services';
import Btn from '../../../ui/Btn';
import { Field } from '../../../ui/Field';
import Select from 'react-select';
import CreatePage from '../../../composents/CreatePage';

const title = 'Users';
const headers = {
	icon: 'feather icon-plus',
	title: title,
	description: 'creation of new user',
	breadcrumbs: [
		{
			title: title,
			link: '/administrators/users',
		},
	],
};

export default function CreateUser() {
	const [loader, setLoader] = useState(false),
		[errors, setErrors] = useState({}),
		[groups, setGroups] = useState([]),
		[group, setGroup] = useState();

	async function onGet() {
		let ent = await resources.group
			.read('all')
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});
		if (ent.status === 200) {
			let a = [];
			const data = ent.data.docs.filter(
				(e) =>
					!e.client &&
					(e.title !== 'customer' || e.role !== 'customer')
			);
			data.forEach((el) => {
				a.push({
					value: el.id,
					label: el.title + ' | ' + el.role,
				});
			});
			setGroups(a);
		}
	}

	useEffect(() => {
		onGet();
	}, []);

	/**
	 * @param {React.FormEvent<HTMLFormElement>} e
	 */
	async function onCreate(e) {
		e.preventDefault();
		let formData = new FormData(e.target);
		let object = {};
		formData.forEach((value, key) => (object[key] = value));
		if (group) object.group = group;
		setLoader(true);
		setErrors({});
		let res = await resources.user
			.create(object)
			.then((responses) => {
				return responses;
			})
			.catch((error) => {
				return Object.assign({}, error).response;
			});
		if (res.status === 200) {
			sessionStorage.setItem('success', true);
			window.location.replace('/administrators/users');
		} else if (res.status === 422) {
			setErrors(
				res.data.errors.reduce((acc, error) => {
					return { ...acc, [error.field]: error.message };
				}, {})
			);
		} else if (res.status === 403) {
			setErrors({ not_autorized: true });
		}
		setLoader(false);
	}

	return (
		<CreatePage show_error={errors['not_autorized']} headers={headers}>
			<form onSubmit={onCreate}>
				<div className="row justify-content-center mt-3 mb-3">
					<div className="col-lg-6 ">
						<div className="card">
							<div className="card-header">
								<h5>Information</h5>
							</div>
							<div className="card-body">
								<Field
									name="fullName"
									className="mb-3"
									error={errors['fullName']}
									required
								>
									User name
								</Field>

								<Field
									type="email"
									name="email"
									className="mb-3"
									error={errors['email']}
									required
								>
									Email
								</Field>

								<div className="form-group mb-3">
									<label
										htmlFor="exampleInputEmail1"
										className="form-label"
									>
										User group{' '}
										<span style={{ color: 'red' }}>*</span>
									</label>
									<Select
										onChange={(e) => setGroup(e.value)}
										options={groups}
										isSearchable
										isClearable
										className={
											errors['group'] ? ' is-invalid' : ''
										}
									/>
									{errors['group'] && (
										<div className="invalid-feedback">
											{errors['group']}
										</div>
									)}
								</div>

								<Field
									name="password"
									type="password"
									className="mb-3"
									error={errors['password']}
									required
								>
									Password
								</Field>

								<Field
									name="password_confirmation"
									type="password"
									error={errors['password_confirmation']}
									className="mb-3"
									required
								>
									password confirmation
								</Field>

								<div className="row ">
									<div className="col-lg-12">
										<div className="d-grid gap-2">
											<Btn
												class="btn waves-effect waves-light btn-primary"
												onLoad={loader}
											>
												<i className="feather icon-save"></i>{' '}
												Submit
											</Btn>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</CreatePage>
	);
}
